import { ActiveOptions, BooleanOptions } from "@/components/constants"
import { WidgetType } from "@evercam/shared/types"

export default {
  active: {
    component: "SelectSearchFilter",
    attributes: {
      items: [{ name: "All", value: "" }, ...ActiveOptions],
    },
  },
  isPublic: {
    component: "SelectSearchFilter",
    attributes: {
      items: [{ name: "All", value: "" }, ...BooleanOptions],
    },
  },
  widgetType: {
    component: "SelectSearchFilter",
    attributes: {
      items: [
        { name: "All", value: "" },
        ...Object.values(WidgetType).map((value) => ({
          name: value,
          value,
        })),
      ],
    },
  },
  ressources: {
    component: "TextFieldSearchFilter",
  },
  user: {
    component: "TextFieldSearchFilter",
  },
  allowedOrigin: {
    component: "TextFieldSearchFilter",
  },
}
